"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = void 0;
const react_1 = __importStar(require("react"));
const STORAGE_KEY = 'happy5-theme';
const ThemeContext = (0, react_1.createContext)({
    mode: 'auto',
    resolved: 'light',
    setMode: () => undefined
});
const readStoredMode = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark' || stored === 'auto') {
            return stored;
        }
    }
    catch {
        // ignore storage errors (private mode, etc.)
    }
    return 'auto';
};
const prefersDark = () => typeof window !== 'undefined' &&
    !!window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;
// 'auto' resolves against the OS preference; 'light'/'dark' are themselves.
const resolveMode = (mode, systemDark) => {
    if (mode !== 'auto') {
        return mode;
    }
    return systemDark ? 'dark' : 'light';
};
const applyMode = (mode) => {
    const root = document.documentElement;
    if (mode === 'auto') {
        root.removeAttribute('data-theme');
    }
    else {
        root.setAttribute('data-theme', mode);
    }
};
const ThemeProvider = ({ children }) => {
    const [mode, setModeState] = (0, react_1.useState)(readStoredMode);
    const [resolved, setResolved] = (0, react_1.useState)(resolveMode(mode, prefersDark()));
    const setMode = (0, react_1.useCallback)((next) => {
        setModeState(next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        }
        catch {
            // ignore storage errors
        }
        applyMode(next);
    }, []);
    (0, react_1.useEffect)(() => {
        applyMode(mode);
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const update = () => setResolved(resolveMode(mode, mediaQuery.matches));
        update();
        mediaQuery.addEventListener?.('change', update);
        return () => mediaQuery.removeEventListener?.('change', update);
    }, [mode]);
    return (react_1.default.createElement(ThemeContext.Provider, { value: { mode, resolved, setMode } }, children));
};
exports.ThemeProvider = ThemeProvider;
const useTheme = () => (0, react_1.useContext)(ThemeContext);
exports.useTheme = useTheme;
